import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getCategoriaColorClass = (tipo) => {
  switch (tipo) {
    case 'mono_correto': return 'mono-correto';
    case 'trib_correto': return 'trib-correto';
    case 'deveria_tributado': return 'deveria-tributado';
    case 'deveria_mono': return 'deveria-mono';
    case 'cst_divergente': return 'cst-divergente';
    default: return 'mono-correto';
  }
};

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [detailedStats, setDetailedStats] = useState(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/estatisticas`);
      setStats(response.data);
      
      const detailedResponse = await axios.get(`${API}/estatisticas/detalhadas`);
      setDetailedStats(detailedResponse.data);
    } catch (error) {
      console.error("Erro ao buscar estatísticas:", error);
    }
  };

  return (
    <div>
      {/* banner */}
      <div className="hero-banner">
        <div className="hero-content">
          <h1 className="hero-title">Resumo de cadastro de produtos</h1>
        </div>
      </div>

      {/* cards */}
      {stats && (
        <div className="stats-row">
          <div className="stat-item blue">
            <div className="stat-label">Total de Produtos</div>
            <div className="stat-value">{stats.total_produtos.toLocaleString()}</div>
          </div>
          <div className="stat-item orange">
            <div className="stat-label">Pendentes de Correção</div>
            <div className="stat-value">{stats.pendentes_correcao.toLocaleString()}</div>
          </div>
          <div className="stat-item green">
            <div className="stat-label">Já Corrigidos</div>
            <div className="stat-value">{stats.ja_corrigidos.toLocaleString()}</div>
          </div>
          <div className="stat-item teal">
            <div className="stat-label">Cadastrados Corretamente</div>
            <div className="stat-value">{stats.produtos_corretos.toLocaleString()}</div>
          </div>
        </div>
      )}

      {/* breakdown classificacao */}
      {detailedStats && (
        <div className="classification-section" style={{ marginTop: "24px" }}>
          <div className="classification-header">
            <h2 className="classification-title">Informações com base na classificação fiscal de produtos</h2>
            <div className="classification-total">
              Valor Total: <span className="classification-total-value">
                R$ {detailedStats.valor_total_geral.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          </div>
          <div className="classification-grid">
            {detailedStats.categorias.map((categoria, index) => (
              <div key={index} className="classification-item">
                <div className={`classification-color-bar ${getCategoriaColorClass(categoria.tipo)}`}></div>
                <div className="classification-info">
                  <div className="classification-name">{categoria.nome}</div>
                  <div className="classification-metrics">
                    <span className="classification-value">
                      R$ {categoria.valor_total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                    <span className="classification-count">
                      {categoria.quantidade.toLocaleString()} produtos
                    </span>
                  </div>
                </div>
                <div className="classification-percentage">
                  <div className="classification-percentage-value">{categoria.porcentagem}%</div>
                  <div className="classification-percentage-label">do total</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
